<template>
  <VContainer id="technician-dashboard" fluid class="mx-0 pa-0">
    <VRow dense>
      <v-toolbar color="primary" density="comfortable">
        <v-toolbar-title class="text-white">
          {{ sessionStore.loggedUser.username }}
        </v-toolbar-title>
        <v-spacer />
        <div class="d-flex ga-2">
          <v-tooltip location="left">
            <template #activator="{ props }">
              <v-btn icon variant="text" v-bind="props" @click="save">
                <v-icon>mdi-content-save-all</v-icon>
              </v-btn>
            </template>
            Sauvegarder
          </v-tooltip>
        </div>
      </v-toolbar>
    </VRow>
    <VRow dense>
      <VCol cols="12" md="6">
        <v-card class="card">
          <v-card-title
            class="d-flex align-center justify-space-between card-header"
            style="border-left: 4px solid #facd55"
          >
            <span>Tournée du jour</span>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-text-field
              v-model="taskList.codeTournee"
              label="Code tournée"
              density="compact"
              readonly
            />
            <v-autocomplete
              v-model="taskList.taskListStatus"
              :items="taskListStatuses"
              density="compact"
              label="Status"
            />
          </v-card-text>
        </v-card>
      </VCol>
      <VCol cols="12" md="6">
        <v-card class="card">
          <v-card-title
            class="d-flex align-center justify-space-between card-header"
            style="border-left: 4px solid #ffbbff"
          >
            <span>Véhicule</span>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-autocomplete
              v-model="taskList.vehicleId"
              :items="vehicles"
              item-title="label"
              item-value="id"
              density="compact"
              label="Véhicule"
            />
          </v-card-text>
          <v-divider />
        </v-card>
      </VCol>
    </VRow>
    <VRow dense>
      <VCol cols="12" md="6">
        <v-card class="card">
          <v-card-title
            class="d-flex align-center justify-space-between card-header"
            style="border-left: 4px solid #aacc80"
          >
            <span>Addresse de départ</span>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-text-field
              label="Numéro"
              v-model="taskList.startAddress.numero"
              density="compact"
            />
            <v-text-field
              label="Rue"
              v-model="taskList.startAddress.rue"
              density="compact"
            />
            <v-text-field
              label="Code postal"
              v-model="taskList.startAddress.codepostale"
              density="compact"
            />
            <v-text-field
              label="Ville"
              v-model="taskList.startAddress.ville"
              density="compact"
            />
          </v-card-text>
        </v-card>
      </VCol>
      <VCol cols="12" md="6">
        <v-card class="card">
          <v-card-title
            class="d-flex align-center justify-space-between card-header"
            style="border-left: 4px solid #ff0000"
          >
            <span>Addresse d'arrivée</span>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-text-field
              label="Numéro"
              v-model="taskList.endAddress.number"
              density="compact"
            />
            <v-text-field
              label="Rue"
              v-model="taskList.endAddress.street"
              density="compact"
            />
            <v-text-field
              label="Code postal"
              v-model="taskList.endAddress.postcode"
              density="compact"
            />
            <v-text-field
              label="Ville"
              v-model="taskList.endAddress.city"
              density="compact"
            />
          </v-card-text>
        </v-card>
      </VCol>
    </VRow>
    <VRow>
      <VCol cols="12" md="6">
        <v-card class="card">
          <v-toolbar
            style="border-left: 4px solid #0000ff"
            density="compact"
            class="card-header"
          >
            <v-toolbar-title>
              Laveries à visiter
              <v-chip size="small" color="primary" variant="tonal">
                {{ tasks.length }}
              </v-chip>
            </v-toolbar-title>

            <v-spacer />

            <v-btn icon size="small" @click="optimizeRoute">
              <v-icon>mdi-map-marker-distance</v-icon>
            </v-btn>
          </v-toolbar>

          <v-divider />

          <v-card-text class="laundry-scroll">
            <draggable
              v-model="tasks"
              item-key="id"
              handle=".drag-handle"
              animation="200"
              ghost-class="drag-ghost"
              @end="onDragEnd"
            >
              <template #item="{ element, index }">
                <v-list-item
                  class="laundry-row"
                  link
                  :to="`/interventions/${element.id}`"
                  :class="[
                    index % 2 === 0 ? 'even-row' : 'odd-row',
                    element.priority === 'URGENT' && 'urgent-row',
                  ]"
                >
                  <template #prepend>
                    <!-- Drag Handle -->
                    <v-icon class="drag-handle mr-2" size="18"> mdi-drag </v-icon>

                    <!-- Rank -->
                    <v-chip size="x-small" class="mr-2">
                      {{ index + 1 }}
                    </v-chip>
                  </template>

                  <v-list-item-title class="d-flex align-center">
                    {{ element.name }}

                    <v-chip
                      v-if="element.priority === 'urgent'"
                      size="x-small"
                      color="error"
                      variant="tonal"
                      class="ml-2"
                    >
                      Urgent
                    </v-chip>
                  </v-list-item-title>

                  <v-list-item-subtitle>
                    <p>{{ element.number }} {{ element.street }}</p>
                    <p>{{ element.postcode }} {{ element.city }}</p>
                  </v-list-item-subtitle>

                  <template #append>
                    <v-btn icon size="x-small" @click.stop="moveUp(index)">
                      <v-icon size="16">mdi-chevron-up</v-icon>
                    </v-btn>

                    <v-btn icon size="x-small" @click.stop="moveDown(index)">
                      <v-icon size="16">mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                </v-list-item>
              </template>
            </draggable>
          </v-card-text>
        </v-card>
      </VCol>

      <VCol cols="12" md="6">
        <v-card class="card">
          <v-card-title class="d-flex align-center justify-space-between card-header">
            <span>Activités à faire</span>
            <v-chip size="small" color="primary" variant="tonal"> </v-chip>
          </v-card-title>
          <v-divider />
        </v-card>
      </VCol>
    </VRow>
  </VContainer>
</template>

<script setup lang="ts">
import { useAppStore, useSessionStore } from "@/store";
import { Task, TaskList, TaskListStatus, Vehicle } from "@/types";
import { getTasksByTaskListId } from "@/utils/task-api";
import { getFilteredTaskLists, putTaskList } from "@/utils/tasklist-api";
import { getAllVehicles } from "@/utils/vehicle-api";
import { onMounted, ref } from "vue";
import draggable from "vuedraggable";
1;
const appStore = useAppStore();
const sessionStore = useSessionStore();

const createEmptyTaskList = (): TaskList => ({
  name: "",
  codeTournee: "",
  dateDebut: new Date(),
  dateFin: new Date(),
  technicienIds: [],
  technicienNames: [],
  taskListStatus: TaskListStatus.A_FAIRE,
  label: "",
  startAddress: {
    numero: "",
    rue: "",
    codepostale: "",
    ville: "",
  },
  endAddress: {
    street: "",
    city: "",
    number: "",
    postcode: "",
  },
});

const taskListStatuses = [TaskListStatus.EN_COURS, TaskListStatus.FAITE];
const taskList = ref<TaskList>(createEmptyTaskList());
const tasks = ref<Task[]>([]);
const vehicles = ref<Vehicle[]>([]);
const loading = ref(false);

async function save() {
  try {
    loading.value = true;
    await putTaskList(taskList.value.id, taskList.value);
    appStore.sendSuccessNotice("TaskList has been updated.");
  } catch (e) {
    // Ignore because it's handled in axios service
  } finally {
    loading.value = false;
  }
}

async function optimizeRoute() {}

async function onDragEnd() {
  // Recalculate ranks
  tasks.value.forEach((l, i) => {
    l.rank = i + 1;
  });

  await saveRanks();
}

async function saveRanks() {
  try {
    await fetch("/api/laundries/rank", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tasks.value),
    });
  } catch (e) {
    console.error("Failed saving ranks", e);
  }
}

function moveUp(index: number) {
  if (index === 0) return;
  tasks.value.splice(index - 1, 0, tasks.value.splice(index, 1)[0]);
  onDragEnd();
}

function moveDown(index: number) {
  if (index === tasks.value.length - 1) return;
  tasks.value.splice(index + 1, 0, tasks.value.splice(index, 1)[0]);
  onDragEnd();
}

onMounted(async () => {
  try {
    const userId = sessionStore.loggedUser.id;
    if (!userId) {
      return;
    }

    const taskLists = await getFilteredTaskLists(
      Array.of(TaskListStatus.ASSIGNE, TaskListStatus.EN_COURS, TaskListStatus.FAITE),
      userId,
      new Date()
    );
    if (taskLists.length === 0) {
      appStore.sendInfoNotice("Aucune tournée assignée pour aujourd'hui");
      return;
    }

    if (taskLists.length > 1) {
      appStore.sendErrorNotice("Plusieurs tournées assignées pour aujourd'hui");
      return;
    }

    taskList.value = taskLists[0];
    const [allTasks, allVehicles] = await Promise.all([
      getTasksByTaskListId(taskList.value.id),
      getAllVehicles(),
    ]);
    tasks.value = allTasks;
    vehicles.value = allVehicles;
  } catch (error) {
    // Ignore
  }
});
</script>

<style scoped>
.card {
  height: 320px;
  display: flex;
  flex-direction: column;
}

.card-header {
  padding-left: 12px;
}

.laundry-scroll {
  max-height: 320px;
  overflow-y: auto;
}

.laundry-row {
  padding: 10px 8px;
}

.drag-handle {
  cursor: grab;
  opacity: 0.6;
}

.drag-ghost {
  opacity: 0.4;
}

.even-row {
  background: rgba(0, 0, 0, 0.02);
}

.odd-row {
  background: rgba(0, 0, 0, 0.08);
}

.urgent-row {
  border-left: 4px solid rgb(var(--v-theme-error));
}
</style>
